import React, { useEffect, useMemo, useState, Fragment } from "react";

import {
  Divider,
  Grid,
  Typography,
  LinearProgress,
  styled,
  Skeleton,
} from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../components/ui/Button";
import { useNavigate, useLocation } from "react-router-dom";
import MainHeading from "../../../components/ui/MainHeading";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedIndex,
  setProdcuctName,
} from "../../../services/redux/slices/tabsSlice";
import { setSelectedloanAccountNumber } from "../../../services/redux/slices/optionSlice";
import { setloanAccountNumberOptions } from "../../../services/redux/slices/optionSlice";
import ModalPopup from "../../../components/ui/ModalPopup";
import AccountSelector from "../../../components/ui/AccountSelectorWithLable";
import { Box, useMediaQuery, useTheme } from "@mui/system";
import { flexiCheckPercentage, formatIndianRupees,handlePercentAmountFlexi } from "../../../utils/formatting";
import service from "../../../services/api/service";
import queryString from "query-string";
import {
  setDashboardData,
  setSelectedLoanNumber,
} from "../../../services/redux/slices/dashboardDataSlice";
import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import { ROUTES } from "../../../routes/routerConfig";
import {
  authSelector,
  userLoanCatSelector,
  userPermissionSelector,
} from "../../../services/redux/slices/authSlice";
import {
  setStatusPopup,
  statusPopupSelector,
} from "../../../services/redux/slices/statusPopupSlice";
import { messages } from "../../../data/constant";
import { flexiLoanPermissionCheck } from "../../../utils/helpers";
import { encrypt } from "../../../utils/crypto";
import postsServices from "../../../services/api/service/postsService";
import Card from "../../../components/ui/Card";
import {
  SmallButton,
  OutlinedSmallButton,
} from "../../../components/ui/Button";
import CustomTabs from "../../../components/ui/Tabs";
import Withdraw from "./Withdraw";
import Payment from "./Payment";
import DocumentTerm from "../../../pages/dashboard/termLoan/DocumentTerm";
import UtilizedIcon from "../../../assets/images/icons/utilized.png";
import AvailableIcon from "../../../assets/images/icons/available.png";
import AccountSelectorDropDown from "../../../components/ui/AccountSelectorDropDown";
import Statement from "./Statement";
import { formatISOToDDMMYYYY } from "../../../utils/dateFormatUtils";


interface QueryParams {
  cif: any;
  business?: any;
  loanCategory?: any;
}
const SanctionedDisbursed = () => {
  const [sanctionedDisbursedData, setSanctionedDisbursedData] = useState<any[]>(
    []
  );
  const { userProfile, businessType } = useSelector(authSelector);
  const { rolePermissions } = useSelector(userPermissionSelector);
  const [isLoading, setIsLoading] = useState(true);
  const [cifId, setCifId] = useState("");

  const navigate = useNavigate();
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [withdrawLanNumber, setWithdrawLanNumber] = useState("");
  const { refreshValue } = useSelector(statusPopupSelector);
  const userLoanCategory = useSelector(userLoanCatSelector);
  const selectedIndex = useSelector((state: any) => state?.tabs?.selectedIndex ?? 0);

  const selectedloanAccountNumber = useSelector((state: any) => state?.dashboardData?.selectedLoanNumber ?? "");

  const location = useLocation();

  const loanAccountNumberOptions = useSelector((state: any) => state ?? [])

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    // Optional: Add analytics tracking if you have trackEvent and decrypt utilities for Flexi
    // trackEvent(tabsContent?.[newValue]?.label == "History" ? "Dashboard_History" : tabsContent?.[newValue]?.label, decrypt(userProfile?.id), {
    //   label: tabsContent?.[newValue]?.label == "History" ? "Dashboard_History" : tabsContent?.[newValue]?.label,
    //   category: 'Tabs',
    //   action: tabsContent?.[newValue]?.label == "History" ? "Dashboard_History" : tabsContent?.[newValue]?.label,
    // });
    const { isValidDate, message } = checkWithdrawal(selectedloanAccountNumber);
    if(newValue === 1 && isValidDate === true) {
      dispatch(
        setStatusPopup({
          status: "Uh-oh! Withdrawal is on hold!",
          message: message,
        })
      );
      return;
    }

    if (!isLoading) {

      const cleanPath = location.pathname ? location.pathname : "/";
      navigate(cleanPath, { replace: true });
      if (newValue === 1) {
        localStorage.removeItem("selectedIndex");
        dispatch(setSelectedIndex(newValue));
      } else if (newValue === 2) {
        localStorage.setItem("selectedIndex", newValue.toString());
        dispatch(setSelectedIndex(newValue));
      } else {
        localStorage.removeItem("selectedIndex");
        dispatch(setSelectedIndex(newValue));
      }

    }

  };

  useEffect(() => {
    const selectedIndex = localStorage.getItem("selectedIndex");
    if (selectedIndex) {
      dispatch(setSelectedIndex(parseInt(selectedIndex)));
    }
  }, []);

  // Retrieve data when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      const isEntity =
        businessType?.name === "entity" &&
          userLoanCategory?.Flexi[0]?.loanCategoryId == 1
          ? true
          : false;
      const flexi = userLoanCategory?.Flexi[0];


      let queryParams: QueryParams = {
        cif: userProfile?.cifEntity,
        business: encrypt(flexi?.businessId),
        loanCategory: encrypt(flexi?.loanCategoryId),
      };

      // const queryParamsString = queryString.stringify(queryParams);
      try {
        setIsLoading(true);
        postsServices
          .addPost("/api/v1/dashboard/getFinanceWithCustomer", queryParams)
          .then((response) => {
            setIsLoading(false);
            dispatch(setDashboardData(response?.data?.data));
            setSanctionedDisbursedData(response?.data?.data);
            const responseData: any = response?.data?.data;
            const flexiLoanData: any = responseData?.map((item: any) => item?.loanAccountNumber);
            if(!selectedloanAccountNumber && flexiLoanData?.length > 0){
              dispatch(setSelectedLoanNumber(flexiLoanData[0]));
            }
            dispatch(setloanAccountNumberOptions(flexiLoanData));
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.details?.error ||
              messages.withdrErrorMessages.commonError;
            dispatch(
              setStatusPopup({ status: "error", message: errorMessage })
            );
            setIsLoading(false);
          });
      } catch (error: any) {
        if (error?.response?.status === 408) {
          const errorMessage = error?.response?.data?.details?.error;
          dispatch(
            setStatusPopup({
              status: "error",
              message: errorMessage,
              buttonStatus: true,
            })
          );
        } else if (error?.response?.data) {
          const errorMessage = error?.response?.data?.message;
          dispatch(
            setStatusPopup({
              status: "error",
              message: errorMessage,
            })
          );
        }

        setIsLoading(false);
      }
    };

    fetchData();
  }, [userProfile?.cifNumber]);

  const dispatch = useDispatch();

  const handleViewDetailsClick = (loanAccountNumber: any) => {
  const { isValidDate, message } = checkWithdrawal(loanAccountNumber);
    if(isValidDate === true) {
      dispatch(
        setStatusPopup({
          status: "Uh-oh! Withdrawal is on hold!",
          message: message,
        })
      );
    } else if (
      rolePermissions?.includes("summary_view") ||
      flexiLoanPermissionCheck()
    ) {
      let filterLoanAccountNumber = sanctionedDisbursedData?.map(
        (acc) => acc.loanAccountNumber
      );
      dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
      //dispatch(setSelectedloanAccountNumber(loanAccountNumber));
      dispatch(setDashboardData(sanctionedDisbursedData));

      dispatch(setSelectedLoanNumber(loanAccountNumber));
      // navigate(ROUTES?.Dashboard?.flexiTermLoan?.locationPath);
      dispatch(setSelectedIndex(1));
      dispatch(setProdcuctName("FlexiTermLoan"));
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Account Summary"`,
        })
      );
    }
  };


  const checkWithdrawal = (loanAccountNumber: any) => {
    let filterLoanAccountNumber = sanctionedDisbursedData?.filter((acc) => {
      if (loanAccountNumber === acc.loanAccountNumber) {
        return acc;
      }
    });

    const nextRepayDate = new Date(filterLoanAccountNumber?.[0]?.nextRepayDate);
    const nextRepayDay = nextRepayDate.getDate(); // e.g. 19

    const currentDate = new Date();
    const currentDay = currentDate.getDate();

    const minDay = nextRepayDay - 2; // 19 - 2 = 17

    // Returns true only if currentDay falls between nextRepayDay and nextRepayDay - 2
    const isValidDate = currentDay >= minDay && currentDay <= nextRepayDay;

    return {
      // message: `Withdrawal requests are restricted between the ${minDay}th to ${nextRepayDay}th of every month. Please try again after the ${nextRepayDay}.`,
      message: `Withdrawal requests are disabled between ${minDay} and ${nextRepayDay} of every month. Please submit your request after your EMI date ${formatISOToDDMMYYYY(nextRepayDate)}.`,
      isValidDate,
    };
  };


  const handleViewAccountSummary = (loanAccountNumber: any) => {
    if (
      rolePermissions?.includes("summary_view") ||
      flexiLoanPermissionCheck()
    ) {
      let filterLoanAccountNumber = sanctionedDisbursedData?.map(
        (acc) => acc.loanAccountNumber
      );
      dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
      dispatch(setDashboardData(sanctionedDisbursedData));
      dispatch(setSelectedLoanNumber(loanAccountNumber));
      navigate(ROUTES?.Dashboard?.flexiTermLoan?.accountSummary?.locationPath);
      // dispatch(setSelectedIndex(1));
      dispatch(setProdcuctName("FlexiTermLoan"));
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Account Summary"`,
        })
      );
    }
  }

  const handlePaymentClick = (loanAccountNumber: any) => {
    if (
      rolePermissions?.includes("payment_view") ||
      flexiLoanPermissionCheck()
    ) {
      let filterLoanAccountNumber = sanctionedDisbursedData?.map(
        (acc) => acc.loanAccountNumber  
      );
      dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
      dispatch(setSelectedloanAccountNumber(loanAccountNumber));
      dispatch(setDashboardData(sanctionedDisbursedData));
      dispatch(setSelectedLoanNumber(loanAccountNumber));
      // navigate(ROUTES?.Dashboard?.flexiTermLoan?.locationPath);
      dispatch(setSelectedIndex(2));
      dispatch(setProdcuctName("FlexiTermLoan"));
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Payment"`,
        })
      );
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleOpen = (loanAccountNumber: any, overdueAmount: any) => {
    if (
      rolePermissions?.includes("withdraw_view") ||
      flexiLoanPermissionCheck()
    ) {
      let overdueAmountValue = overdueAmount / 100;
      if (overdueAmountValue > 100) {
        setIsModalOpen(true);
        setWithdrawLanNumber(loanAccountNumber);
      } else {
        let filterLoanAccountNumber = sanctionedDisbursedData?.map(
          (acc) => acc.loanAccountNumber
        );
        dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
        //dispatch(setSelectedloanAccountNumber(loanAccountNumber));
        dispatch(setDashboardData(sanctionedDisbursedData));
        //dispatch(setSelectedLoanNumber(loanAccountNumber));
        navigate(ROUTES?.Dashboard?.flexiTermLoan?.locationPath);
        dispatch(setSelectedIndex(1));
        dispatch(setProdcuctName("FlexiTermLoan"));
      }
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Withdraw"`,
        })
      );
    }
  };

  const handleNavigate = () => {
    let filterLoanAccountNumber = sanctionedDisbursedData?.map(
      (acc) => acc.loanAccountNumber
    );
    dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
    dispatch(setSelectedloanAccountNumber(withdrawLanNumber));
    dispatch(setDashboardData(sanctionedDisbursedData));
    dispatch(setSelectedLoanNumber(withdrawLanNumber));
    navigate(ROUTES?.Dashboard?.flexiTermLoan?.locationPath);
    dispatch(setSelectedIndex(2));
  };

  const MultiColorProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: "rgba(22, 135, 148, 1)",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)",
    },
  }));

  const sortedFlexiLoanData = useMemo(() => {
    return [...sanctionedDisbursedData].sort((a, b: any) =>
      a.statusOfLoan === "A" ? -1 : b.statusOfLoan === "A" ? 1 : 0
    );
  }, [sanctionedDisbursedData]);

  const tabsContent: any = [
    { label: "Loan", content: "" },
    { label: "Withdrawal", content: "" },
    { label: "Payment", content: "" },
    { label: "Documents", content: "" },
  ];


  return (
    <React.Fragment>
      {!isXsOrSm && (
        <Box>
          <CustomTabs content={tabsContent} onChange={handleChange} value={selectedIndex} />
        </Box>
      )}
      {selectedIndex == 0 && (
        <>
          <Grid container>
            {isLoading ? (
              <Box sx={{ width: "100%" }}>
                {[...Array(isXsOrSm ? 1 : 2)].map((_, skeletonCardIndex) => (
                  <Box className="dashboard-container" key={`flexi-skeleton-${skeletonCardIndex}`}>
                    <Card>
                      {isXsOrSm ? (
                        <>
                          <Grid container className="active-button-container" style={{ marginTop: "5px" }}>
                            <Grid item xs={9}>
                              <Skeleton variant="text" width={130} height={18} animation="wave" />
                              <Skeleton
                                variant="rectangular"
                                width="95%"
                                height={36}
                                animation="wave"
                                sx={{ borderRadius: 2, mt: 0.5 }}
                              />
                            </Grid>
                            <Grid item xs={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                              <Skeleton variant="rounded" width={64} height={24} animation="wave" />
                            </Grid>
                          </Grid>

                          <Divider sx={{ my: 1.5 }} />

                          <Grid container className="mt-10" spacing={2}>
                            <Grid item xs={12} className="mb-20">
                              <Grid container className="muiLinearProgress">
                                <Grid item xs={6} className="right-border">
                                  <Skeleton variant="text" width={90} height={18} animation="wave" />
                                  <Skeleton variant="text" width={110} height={28} animation="wave" />
                                  <Skeleton variant="text" width={75} height={18} animation="wave" />
                                </Grid>
                                <Grid item xs={6}>
                                  <Skeleton variant="text" width={90} height={18} animation="wave" sx={{ ml: "auto" }} />
                                  <Skeleton variant="text" width={110} height={28} animation="wave" sx={{ ml: "auto" }} />
                                  <Skeleton variant="text" width={75} height={18} animation="wave" sx={{ ml: "auto" }} />
                                </Grid>
                                <Grid item xs={12}>
                                  <Skeleton
                                    variant="rounded"
                                    width="100%"
                                    height={12}
                                    animation="wave"
                                    sx={{ mt: 2, borderRadius: 5 }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12} className="dashboard-container-mobile">
                              <Grid container spacing={2}>
                                {[...Array(6)].map((__, idx) => (
                                  <Grid item xs={4} key={`mobile-metric-${idx}`}>
                                    <Skeleton variant="text" width="75%" height={16} animation="wave" />
                                    <Skeleton variant="text" width="88%" height={26} animation="wave" />
                                  </Grid>
                                ))}
                              </Grid>
                            </Grid>

                            <Grid container className="mt-20 mb-20">
                              <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                                <Skeleton variant="rounded" width={80} height={34} animation="wave" />
                                <Skeleton variant="rounded" width={100} height={34} animation="wave" />
                                <Skeleton variant="rounded" width={70} height={34} animation="wave" />
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid container className="active-button-container" alignItems="center">
                            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ height: "22px" }}>
                              <Skeleton variant="text" width={220} height={30} animation="wave" />
                              <Skeleton variant="text" width={150} height={20} animation="wave" sx={{ mt: 1 }} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                              <Skeleton variant="rounded" width={100} height={34} animation="wave" />
                              <Skeleton variant="rounded" width={100} height={34} animation="wave" />
                              <Skeleton variant="rounded" width={90} height={34} animation="wave" />
                            </Grid>
                          </Grid>

                          <Divider sx={{ my: 2 }} />

                          <Grid container className="mt-20">
                            <Grid item xs={12} sm={7}>
                              <Grid container spacing={4}>
                                {[...Array(6)].map((__, idx) => (
                                  <Grid item sm={4} key={`desktop-metric-${idx}`}>
                                    <Skeleton variant="text" width={95} height={18} animation="wave" />
                                    <Skeleton variant="text" width={120} height={28} animation="wave" />
                                  </Grid>
                                ))}
                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={5}>
                              <div style={{ display: "flex" }}>
                                <div className="line-container">
                                  <div className="line vertical"></div>
                                  <div className="line vertical"></div>
                                </div>
                                <Grid container className="muiLinearProgress">
                                  <Grid item sm={6} className="right-border">
                                    <Skeleton variant="text" width={110} height={18} animation="wave" />
                                    <Skeleton variant="text" width={110} height={28} animation="wave" />
                                    <Skeleton variant="text" width={75} height={18} animation="wave" />
                                  </Grid>
                                  <Grid item sm={6}>
                                    <Skeleton variant="text" width={110} height={18} animation="wave" sx={{ ml: "auto" }} />
                                    <Skeleton variant="text" width={110} height={28} animation="wave" sx={{ ml: "auto" }} />
                                    <Skeleton variant="text" width={75} height={18} animation="wave" sx={{ ml: "auto" }} />
                                  </Grid>
                                  <Grid item sm={12}>
                                    <Skeleton
                                      variant="rounded"
                                      width="100%"
                                      height={12}
                                      animation="wave"
                                      sx={{ mt: 3, borderRadius: 5 }}
                                    />
                                  </Grid>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </Card>
                  </Box>
                ))}
              </Box>
            ) : (
              <>
                {/* {isXsOrSm && (
                  <>
                    <Typography
                      variant="h6"
                      noWrap
                      component="div"
                      sx={{ color: "rgba(39, 87, 92, 1)", fontWeight: 700, fontSize: 18, lineHeight: "25px" }}
                    >
                      Welcome back {userProfile?.name} 👋
                    </Typography>
                    <Typography
                      variant="h5"
                      noWrap
                      component="div"
                      sx={{ color: "rgba(112, 117, 121, 1)", fontWeight: 500, fontSize: 12, lineHeight: "22px" }}
                    >
                      Monitor all your loan accounts from here
                    </Typography>
                  </>
                )} */}


                <Box sx={{ width: "100%" }}>
                  {sortedFlexiLoanData.length === 0 ? (
                    <Card>
                      <Box className="dashboard-container">
                        <Typography variant="h6">No Flexi Term Loans found.</Typography>
                      </Box>
                    </Card>
                  ) : (
                    sortedFlexiLoanData.map((item: any, index: number) => (
                      isXsOrSm ? (
                        // Mobile Layout
                        <>
                          {selectedloanAccountNumber === item?.loanAccountNumber && (
                            <Box className="dashboard-container" key={index}>
                              <Card>
                                <Grid container className="active-button-container" style={{ marginTop: "5px" }}>
                                  <Grid item xs={9} sm={9} md={7} lg={7}>
                                    <Box sx={{ float: "left" }}>
                                      <AccountSelectorDropDown
                                        labelText="Loan account number"
                                        buttonText=" N/A"
                                        isActive={""}
                                        backgroundColor="transparent"
                                        borderWidth="0px"
                                        marginTop="0px"
                                      />
                                    </Box>
                                  </Grid>
                                  <Grid item xs={3} sm={3} md={5} lg={5}>
                                    <Typography
                                      className="active-button-mobile"
                                      style={{
                                        color: item?.statusOfLoan === "A" ? "#28C76F" : "#EA5455",
                                        backgroundColor: item?.statusOfLoan === "A" ? "#28C76F29" : "#EA545529",
                                      }}
                                    >
                                      {item?.statusOfLoan === "A" ? "Active" : "Closed"}
                                    </Typography>
                                  </Grid>
                                  <Divider
                                    sx={{
                                      border: isXsOrSm ? "" : "1px solid rgba(219, 218, 222, 1)",
                                      borderColor: isXsOrSm ? "rgba(0, 0, 0, 0.12)" : "",
                                      borderBottomWidth: isXsOrSm ? "thin" : "",
                                      width: "100%",
                                      marginTop: "6px",
                                      marginBottom: "10px",
                                    }}
                                  />
                                </Grid>
                                <Grid container className="mt-10">
                                  <Grid item xs={12} sm={5} md={5} lg={5} className="mb-20">
                                    <div style={{ display: "flex" }}>
                                      <Grid container sm className="muiLinearProgress">
                                        {/* Utilised Section */}
                                        <Grid item xs={6} sm={6} md={6} lg={6} className="right-border">
                                          <Typography className="mainHeadingLable muiLinear-progress-p">
                                            <img
                                              src={UtilizedIcon}
                                              alt="Utilized"
                                              style={{
                                                height: "22px",
                                              }}
                                            />
                                            <span className="left-side-span">Utilised Limit</span>
                                          </Typography>
                                          <Typography className="mainHeadingValueMobile">
                                            {formatIndianRupees(item?.limitUtilization)}
                                          </Typography>
                                          <Typography className="mainHeadingPerValueMobile">
                                            {/* {parseFloat(flexiCheckPercentage(item))} */}
                                             {handlePercentAmountFlexi(
                                                item?.totalLimit,
                                                item?.limitUtilization,
                                                item?.availableLimit,
                                                "disburse"
                                              )} % used
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6} lg={6}>
                                          <Typography className="mainHeadingLable  text-align-right">
                                            <img
                                              src={AvailableIcon}
                                              alt="Available"
                                              style={{
                                                height: "22px",
                                              }}
                                            />
                                            <span className="right-side-span">Available Limit</span>
                                          </Typography>
                                          <Typography className="mainHeadingValueMobile text-align-right mainHeadingValueMobileRight">
                                            {formatIndianRupees(item?.availableLimit)}
                                          </Typography>
                                          <Typography className="mainHeadingPerValueMobile text-align-right">
                                            {/* {100 - parseFloat(flexiCheckPercentage(item))} */}
                                              {handlePercentAmountFlexi(
                                                item?.totalLimit,
                                                item?.limitUtilization,
                                                item?.availableLimit,
                                                "sanction"
                                              )} % left
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                          <Box sx={{ width: "100%", marginTop: 1 }}>
                                            <MultiColorProgressBar variant="determinate"
                                              value={flexiCheckPercentage(item)} />
                                          </Box>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  </Grid>
                                  <Grid item xs={12} sm={7} md={7} lg={7} className="dashboard-container-mobile">
                                    <Grid container spacing={2}>
                                      <Grid item xs={4} sm={4} md={4} lg={4}>
                                        <Typography className="insidePageLableMobile">Total Limit</Typography>
                                        <Typography variant="subtitle1" className="insidePageValueMobile">
                                          {formatIndianRupees(item?.totalLimit)}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={4} sm={4} md={4} lg={4}>
                                        <Typography className="insidePageLableMobile">ROI</Typography>
                                        <Typography variant="subtitle1" className="insidePageValueMobile">
                                          {item?.ROI}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={4} sm={4} md={4} lg={4}>
                                        <Typography className="insidePageLableMobile">Available Limit</Typography>
                                        <Typography variant="subtitle1" className="insidePageValueMobile">
                                          {formatIndianRupees(item?.availableLimit)}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    <Grid container spacing={2} mt={1}>
                                      <Grid item xs={4} sm={4} md={4} lg={4}>
                                        <Typography className="insidePageLableMobile">Tenure</Typography>
                                        <Typography variant="subtitle1" className="insidePageValueMobile">
                                          {item?.tenure}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={4} sm={4} md={4} lg={4}>
                                        <Typography className="insidePageLableMobile">Processing Fee</Typography>
                                        <Typography variant="subtitle1" className="insidePageValueMobile">
                                          {formatIndianRupees(item?.processingFee)}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={4} sm={4} md={4} lg={4}>
                                        <Typography className="insidePageLableMobile">AMC</Typography>
                                        <Typography variant="subtitle1" className="insidePageValueMobile">
                                          {formatIndianRupees(item?.AMC)}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid container className="mt-20 mb-20">
                                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
                                      <Box sx={{ float: "right", display: "flex", gap: 1 }}>
                                        <SmallButton
                                          title={isXsOrSm ? "Pay" : "Pay Now"}
                                          sx={{ minWidth: { xs: "80px", sm: "100px" } }} // responsive button width
                                          click={() => handlePaymentClick(item?.loanAccountNumber)}
                                        />
                                        <SmallButton
                                          title={"Withdrawal"}
                                          click={() => handleViewDetailsClick(item?.loanAccountNumber)}
                                        />
                                        <OutlinedSmallButton
                                          title={"View"}
                                          click={() => handleViewAccountSummary(item?.loanAccountNumber)}
                                        />
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Box>
                          )}
                        </>
                      ) : (
                        // Desktop Layout (existing)
                        <>
                          {selectedloanAccountNumber === item?.loanAccountNumber && (
                            <>
                              <Box className="dashboard-container" key={index}>
                                <Card>
                                  <Grid container sm className="active-button-container">
                                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ height: "22px" }}>
                                      <Typography variant="h6" className="loan-account-main-heading">
                                        Loan A/c {item?.loanAccountNumber}
                                        <Typography
                                          className="active-button"
                                          style={{
                                            color: item?.statusOfLoan === "A" ? "#28C76F" : "#EA5455",
                                            backgroundColor: item?.statusOfLoan === "A" ? "#28C76F29" : "#EA545529",
                                          }}
                                        >
                                          {item?.statusOfLoan === "A" ? "Active" : "Closed"}
                                        </Typography>
                                      </Typography>
                                      <Typography className="loan-account-sub-heading">
                                        {item?.productType}
                                      </Typography>
                                    </Grid>
                                    <Grid item sm={6} sx={{ display: "flex", justifyContent: "right", alignItems: "right", gap: 2 }}>
                                      <SmallButton
                                        title={"Pay Now"}
                                        click={() => handlePaymentClick(item?.loanAccountNumber)}
                                      />
                                      <SmallButton
                                        title={"Withdrawal"}
                                        click={() => handleViewDetailsClick(item?.loanAccountNumber)}
                                      />
                                      <OutlinedSmallButton
                                        title={"View Detail"}
                                        click={() => handleViewAccountSummary(item?.loanAccountNumber)}
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid container sm sx={{ paddingTop: "20px" }}>
                                    <Grid item sm={12}>
                                      <Divider
                                        sx={{
                                          border: isXsOrSm ? "" : "1px solid rgba(219, 218, 222, 1)",
                                          borderColor: isXsOrSm ? "rgba(0, 0, 0, 0.12)" : "",
                                          borderBottomWidth: isXsOrSm ? "thin" : "",
                                          width: "100%",
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid container className="mt-20">
                                    <Grid item sm={7}>
                                      <Grid container spacing={4}>
                                        <Grid item sm={4}>
                                          <Typography className="insidePageLable">Total Limit</Typography>
                                          <Typography variant="subtitle1" className="insidePageValue">
                                            {formatIndianRupees(item?.totalLimit)}
                                          </Typography>
                                        </Grid>
                                        <Grid item sm={4}>
                                          <Typography className="insidePageLable">ROI</Typography>
                                          <Typography variant="subtitle1" className="insidePageValue">
                                            {item?.ROI}
                                          </Typography>
                                        </Grid>
                                        <Grid item sm={4}>
                                          <Typography className="insidePageLable">Available Limit</Typography>
                                          <Typography variant="subtitle1" className="insidePageValue">
                                            {formatIndianRupees(item?.availableLimit)}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container spacing={4}>
                                        <Grid item sm={4}>
                                          <Typography className="insidePageLable">Tenure</Typography>
                                          <Typography variant="subtitle1" className="insidePageValue">
                                            {item?.tenure}
                                          </Typography>
                                        </Grid>
                                        <Grid item sm={4}>
                                          <Typography className="insidePageLable">Processing Fee</Typography>
                                          <Typography variant="subtitle1" className="insidePageValue">
                                            {formatIndianRupees(item?.processingFee)}
                                          </Typography>
                                        </Grid>
                                        <Grid item sm={4}>
                                          <Typography className="insidePageLable">AMC</Typography>
                                          <Typography variant="subtitle1" className="insidePageValue">
                                            {formatIndianRupees(item?.amc)}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item sm={5}>
                                      <div style={{ display: "flex" }}>
                                        <div className="line-container">
                                          <div className="line vertical"></div>
                                          <div className="line vertical"></div>
                                        </div>
                                        <Grid container sm className="muiLinearProgress">
                                          <Grid item sm={6} className="right-border">
                                            <Typography className="mainHeadingLable muiLinear-progress-p">
                                              Utilised Limit
                                            </Typography>
                                            <Typography className="mainHeadingValue">
                                              {formatIndianRupees(item?.limitUtilization)}
                                            </Typography>
                                            <Typography className="mainHeadingPerValue">
                                              {/* {parseFloat(flexiCheckPercentage(item))} */}
                                              {handlePercentAmountFlexi(
                                                item?.totalLimit,
                                                item?.limitUtilization,
                                                item?.availableLimit,
                                                "disburse"
                                              )}% used
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={6}>
                                            <Typography className="mainHeadingLable text-align-right">
                                              Available Limit
                                            </Typography>
                                            <Typography className="mainHeadingValue text-align-right mainHeadingValueRight">
                                              {formatIndianRupees(item?.availableLimit)}
                                            </Typography>
                                            <Typography className="mainHeadingPerValue text-align-right">
                                              {/* {100 - parseFloat(flexiCheckPercentage(item))} */}
                                              
                                              {handlePercentAmountFlexi(
                                                item?.totalLimit,
                                                item?.limitUtilization,
                                                item?.availableLimit,
                                                "sanction"
                                              )}% left
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={12}>
                                            <Box sx={{ width: "100%", marginTop: 3 }}>
                                              <MultiColorProgressBar variant="determinate"
                                                value={flexiCheckPercentage(item)} />
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Card>
                              </Box>
                            </>
                          )}
                        </>
                      )
                    ))
                  )}
                </Box>
              </>
            )}
          </Grid>
          <ModalPopup
            isOpen={isModalOpen}
            onClose={handleClose}
            title="Pay your Overdue"
            onNavigate={handleNavigate}
            style={{ borderRadius: "8px", width: "448px", padding: "15px 18px 0px 20px" }}
          >
            <Divider style={{ width: "100%", margin: "10px 0px 10px 0px" }} />
            <Typography variant="body2">
              There is overdue on this account. Please clear it for raising disbursement request.
            </Typography>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <SecondaryButton fullWidth type="submit" onClick={handleClose}>
                  Pay later
                </SecondaryButton>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <PrimaryButton fullWidth type="submit" onClick={handleNavigate} style={{ margin: "20px 0px" }}>
                  Pay Now
                </PrimaryButton>
              </Grid>
            </Grid>
          </ModalPopup>
        </>
      )}
      {selectedIndex == 1 && <Withdraw />}

      {selectedIndex == 2 && (
        <Payment />
      )}
      {selectedIndex == 3 && <Statement />}
    </React.Fragment>
  );
};

export default SanctionedDisbursed;